// @generated by protoc-gen-es v1.10.0
// @generated from file fingertip/common/type/v1/billing_subscription.proto (package fingertip.common.type.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";
import { SubscriptionStatus } from "../../enum/v1/subscription_status_pb.js";
import { OverridePlanName } from "../../enum/v1/override_plan_name_pb.js";

/**
 * @generated from message fingertip.common.type.v1.BillingSubscription
 */
export const BillingSubscription = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.BillingSubscription",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "stripe_subscription_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "site_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "created_at", kind: "message", T: Timestamp },
    { no: 5, name: "updated_at", kind: "message", T: Timestamp },
    { no: 6, name: "cancel_at", kind: "message", T: Timestamp },
    { no: 7, name: "cancel_at_period_end", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "canceled_at", kind: "message", T: Timestamp },
    { no: 9, name: "created", kind: "message", T: Timestamp },
    { no: 10, name: "current_period_end", kind: "message", T: Timestamp },
    { no: 11, name: "current_period_start", kind: "message", T: Timestamp },
    { no: 12, name: "ended_at", kind: "message", T: Timestamp },
    { no: 13, name: "metadata", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "billing_price_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "quantity", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 16, name: "trial_end", kind: "message", T: Timestamp },
    { no: 17, name: "trial_start", kind: "message", T: Timestamp },
    { no: 18, name: "status", kind: "enum", T: proto3.getEnumType(SubscriptionStatus) },
    { no: 19, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 20, name: "override_plan_name", kind: "enum", T: proto3.getEnumType(OverridePlanName) },
    { no: 21, name: "stripe_promotion_code_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 22, name: "stripe_coupon_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

